import React from 'react'
import { Link } from 'react-router-dom'
import { useKeywordTopicApi } from '../../analysis/hooks/useKeywordTopicApi'

export const SeoAnalysisDashboardWidget: React.FC = () => {
    const { overview, insights, loadingOverview, loadingInsights } = useKeywordTopicApi()

    const isLoading = loadingOverview || loadingInsights
    const hasData = !!overview

    if (isLoading) {
        return (
            <div className="card card-custom bg-white shadow-sm mb-5 p-6 border-0">
                <div className="d-flex flex-column align-items-center justify-content-center py-5">
                    <div className="spinner-border text-primary" role="status"></div>
                    <span className="text-gray-400 fw-semibold fs-7 mt-3">Caricamento SEO...</span>
                </div>
            </div>
        )
    }

    if (!hasData) {
        return (
            <div className="card card-custom bg-white shadow-sm mb-5 p-6 border-0">
                <div className="d-flex flex-column justify-content-center align-items-center">
                    <i className="ki-outline ki-magnifier fs-2x text-primary mb-3"></i>
                    <span className="text-gray-800 fw-bold fs-6 mb-1">Analisi SEO</span>
                    <span className="text-gray-400 fw-semibold fs-7">Dati non disponibili</span>
                </div>
            </div>
        )
    }

    const formatCompact = (num: number) => {
        return Intl.NumberFormat('en-US', {
            notation: "compact",
            maximumFractionDigits: 1
        }).format(num);
    }

    // Determine color based on keyword count (just for styling fun)
    const color = 'primary';

    return (
        <div className="card card-custom bg-white shadow-sm mb-5 border-0">
            <div className="card-body p-6">
                {/* Header */}
                <div className="d-flex justify-content-between align-items-start mb-4">
                    <div className="d-flex align-items-center">
                        <i className="ki-outline ki-magnifier fs-2x text-primary me-3"></i>
                        <div>
                            <div className="text-gray-800 fw-bold fs-6">Analisi SEO</div>
                            <div className="text-gray-400 fs-8 fw-semibold">Keyword & Topic AI</div>
                        </div>
                    </div>
                </div>

                {/* Metrics Grid */}
                <div className="d-flex align-items-end justify-content-between mb-4">
                    {/* Main Metric */}
                    <div>
                        <div className="text-gray-500 fw-semibold fs-8 mb-1">Keyword Monitorate</div>
                        <Link to="/analysis/seo" className="d-flex align-items-center text-gray-800 text-hover-primary">
                            <span className="fs-2x fw-bold lh-1 me-2">{formatCompact(overview.keywordTotal)}</span>
                        </Link>
                    </div>

                    {/* Secondary stats */}
                    <div className="d-flex flex-column text-end">
                        <div className="text-gray-800 fw-bold fs-7">{formatCompact(overview.totalVolume)} <span className="text-gray-400 fw-semibold fs-8">Vol.</span></div>
                        <div className="text-gray-800 fw-bold fs-7">{overview.clusterTotal} <span className="text-gray-400 fw-semibold fs-8">Cluster</span></div>
                    </div>
                </div>

                {/* Top Insight */}
                {insights?.topCluster && (
                    <div className={`bg-light-${color} rounded p-3 bg-opacity-10 mb-3`}>
                        <div className="d-flex align-items-center mb-1">
                            <i className="ki-outline ki-crown-2 fs-5 text-warning me-2"></i>
                            <span className="text-gray-800 fw-bold fs-8">Top Trend: {insights.topCluster.name}</span>
                        </div>
                        <p className="text-gray-600 fs-8 mb-0">
                            Rappresenta il <strong>{Math.round(insights.topCluster.weight * 100)}%</strong> del traffico potenziale.
                        </p>
                    </div>
                )}

                <div className="d-flex justify-content-center">
                    <Link to="/analysis/seo" className="btn btn-sm btn-light-primary w-100 py-2 fs-8">
                        Vedi Dettagli
                    </Link>
                </div>
            </div>
        </div>
    )
}
